import * as yup from 'yup'

const validationSchema = () =>
  yup.object().shape({
    discounts_and_sale_newsletter: yup.bool(),
  })

export default validationSchema
